import { WidgetProps } from "@rjsf/core";
import classNames from "classnames";
import { EquipmentBlock } from "components/EquipmentBlock";
import useMediaQuery from "components/utils/useMediaQuery";
import { HeadingLevel } from "types/HeadingLevel";

export const EquipmentBlockWidget = (props: WidgetProps) => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    const { applicationNumber, appSubmitted } = props.formContext ?? {};

    if (props.readonly || appSubmitted) {
        return null;
    }

    return (
        <EquipmentBlock
            applicationNumber={applicationNumber}
            readOnly={props.readonly}
            tableClassName="shadow-sm bg-white"
            headerClassName={classNames({ "align-items-center": !isMobile })}
            mobileTableRowClassName="bg-white rounded-2 shadow-sm"
            mobileRowItemClassName="px-2"
            tableStyle={{ "--bs-table-bg": "var(--table-background-color)" } as React.CSSProperties}
            sectionHeadingLevel={HeadingLevel.H5}
        />
    );
};
